import "./AdminDashboard.css";
import { GestionHeader } from "./SiteHeader";

function AdminDashboard({ user, onNavigate, onLogout }) {
  return (
    <div className="admin-container">
      <GestionHeader
        user={user}
        onNavigate={onNavigate}
        title="Administration"
        onBack={() => onNavigate("home")}
        onHome={() => onNavigate("home")}
        onLogout={onLogout}
      />
      <main className="admin-main">
        <h2>Tableau de bord</h2>
        <p>Bienvenue {user.surname} {user.name}</p>
        <div className="admin-cards">
          <button className="admin-card" onClick={() => onNavigate("users")}>
            <span className="admin-card-icon">👥</span>
            <span className="admin-card-label">Gestion Utilisateurs</span>
          </button>
          <button className="admin-card" onClick={() => onNavigate("cards")}>
            <span className="admin-card-icon">💳</span>
            <span className="admin-card-label">Gestion Cartes</span>
          </button>
          <button className="admin-card" onClick={() => onNavigate("organizations")}>
            <span className="admin-card-icon">🏢</span>
            <span className="admin-card-label">Gestion Organisations</span>
          </button>
          <button className="admin-card" onClick={() => onNavigate("qr-links")}>
            <span className="admin-card-icon">🔗</span>
            <span className="admin-card-label">QR Dynamiques</span>
          </button>
          <button className="admin-card" onClick={() => onNavigate("test-card")}>
            <span className="admin-card-icon">🧪</span>
            <span className="admin-card-label">Test carte</span>
          </button>
          <button className="admin-card" onClick={() => onNavigate("invoices")}>
            <span className="admin-card-icon">🧾</span>
            <span className="admin-card-label">Factures</span>
          </button>
          <button className="admin-card" onClick={() => onNavigate("billing-test")}>
            <span className="admin-card-icon">💶</span>
            <span className="admin-card-label">Test paiement</span>
          </button>
          <button className="admin-card" onClick={() => onNavigate("coupons")}>
            <span className="admin-card-icon">🎟️</span>
            <span className="admin-card-label">Codes de réduction</span>
          </button>
        </div>
      </main>
    </div>
  );
}

export default AdminDashboard;
